import React from "react";
// import i18n from "i18n";
import styles from "./MainApp.BlueSummaryItem.module.scss";

export const BlueSummaryItem = ({ icon, number, label }) => {
  const [firstWord, ...restWords] = label.split(" ");
  const rest = restWords.join(" ");

  return (
    <div className={styles["blue-summary-item-container"]}>
      <div className={styles["blue-summary-item-line"]}></div>
      <div className={styles["group-icon-label"]}>
        <div className={styles["blue-summary-item-icon"]}>
          <img src={icon} alt="logo" className={styles["blue-summary-icon"]} />
        </div>
        <div className={styles["blue-summary-item-label"]}>
          <span>{firstWord}</span>
          <br />
          <span>{rest}</span>
        </div>
      </div>
      <div className={styles["blue-summary-item-number"]}>{number}</div>
    </div>
  );
};

export default BlueSummaryItem;
